import { login as loginService } from "../api";

export const maxLoginLength = 50;
export const maxPasswordLength = 255;

export const validateUserInput = (user: string): string | null => {
  if (user.length > maxLoginLength) {
    return `Máximo de ${maxLoginLength} caracteres permitidos.`;
  }
  if (!/^[a-zA-Z0-9.@\s]*$/.test(user)) {
    return "Apenas letras, números, espaços, (.) e (@) são permitidos.";
  }
  return null;
};

export const isFormValid = (user: string, password: string): boolean => {
  return (
    user.trim() !== "" &&
    password.trim() !== "" &&
    user.length <= maxLoginLength &&
    password.length <= maxPasswordLength &&
    !validateUserInput(user)
  );
};

export const handleLogin = async (
  user: string,
  password: string,
  recaptchaToken: string
): Promise<{ success: boolean; userType?: number }> => {
  try {
    const response = await loginService(user, password, recaptchaToken);
    return { success: true, userType: response.user.type };
  } catch (error) {
    return { success: false };
  }
};
